module.exports = __webpack_public_path__ + "static/media/vedant.e32204f6.jpg";